module.exports = __webpack_public_path__ + "static/media/mk.74974773.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mk.svg
// module id = 2154
// module chunks = 0